import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'codigocliente'})
export class ClientCodePipe implements PipeTransform {
  transform(codigo: any, args: any[]): string {
    return codigo.replace(/^0+/, '');
  }
}


// WEBPACK FOOTER //
// ./src/app/codigocliente.pipe.ts